import * as React from "react";
import { WidthContainer } from "../../ChatFlow/WidthContainer";
import { FormControl, TFormControlProps } from "kanopi-components/Input";
import { Textarea } from "baseui/textarea";
import { SIZE } from "baseui/input";

export const TextareaInput: React.FC<TFormControlProps> = ({
  label,
  title,
  help,
  error,
  hideLabel,
  ...props
}) => {
  const [value, setValue] = React.useState("");
  return (
    <WidthContainer>
      <FormControl
        label={label}
        title={title}
        caption={help}
        error={error}
        hideLabel={hideLabel}
        forceFocus
      >
        <Textarea
          value={value}
          onChange={(e) => setValue(e.currentTarget.value)}
          {...props}
        />
      </FormControl>
    </WidthContainer>
  );
};
